export default function BaoTri() {
  return (
    <div className="min-h-screen bg-[#f8f7f5] flex flex-col items-center justify-center text-center px-6">
      <img src="/logopt2000.png" alt="PT2000 Logo" className="h-16 mb-6" />
      
      <h1 className="text-3xl sm:text-4xl font-bold text-gray-800 mb-4 uppercase">
        Website đang bảo trì
      </h1>
      
      <p className="text-gray-600 text-lg mb-6 max-w-xl">
        PT2000 đang nâng cấp hệ thống để phục vụ bạn tốt hơn. Chúng tôi sẽ quay trở lại trong thời gian sớm nhất. Cảm ơn bạn đã đồng hành!
      </p>

      <div className="flex space-x-4 text-xl text-pink-600">
        <a href="https://facebook.com/pt2000.com.vn" target="_blank" rel="noopener noreferrer">
          Facebook
        </a>
        <span>|</span>
        <a href="tel:0784992000">Hotline: 0784 992 000</a>
      </div>

      <p className="text-sm text-gray-400 mt-10">© PT2000 {new Date().getFullYear()}</p>
    </div>
  );
}
